import { render } from "./VoucherAmountPage.vue?vue&type=template&id=16a0bc3f&scoped=true"
import script from "./VoucherAmountPage.vue?vue&type=script&lang=js"
export * from "./VoucherAmountPage.vue?vue&type=script&lang=js"

import "./VoucherAmountPage.vue?vue&type=style&index=0&id=16a0bc3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a0bc3f"]])

export default __exports__